import React, { FC } from "react";

import {
  LandscapeSection,
  LandscapeTextHead,
  LandscapeTextTail,
  LandscapeContainer,
} from "src/core/App/components/orientationStyles";
import AnobisLandscapeBackground from "src/assets/anobis-landscape-background.svg";
import LockIcon from "src/assets/lock-icon.svg";
import { MinimalModeContent } from "src/api/common";

const OrientationEncapsulator: FC<{
  isPortraitMode: boolean;
  siteHeight: number;
  siteWidth: number;
}> = ({ isPortraitMode, siteHeight, siteWidth, children, ...props }) => {
  // Keeping this as a variable, we can make it 0 later to enable on phone
  return siteWidth < 700 && MinimalModeContent["enabled"] ? (
    <div>
      <LandscapeContainer height={siteHeight}>
        <LandscapeSection height={siteHeight} width={siteWidth}>
          <img className="landscape-background-image" src={LockIcon} alt="Anobis NYE Mode" />
          <LandscapeTextTail>
            <div
              dangerouslySetInnerHTML={{ __html: MinimalModeContent["message"] }}
              style={{ justifyContent: "center", textAlign: "center" }}
            />
          </LandscapeTextTail>
        </LandscapeSection>
      </LandscapeContainer>
    </div>
  ) : !isPortraitMode ? (
    <LandscapeContainer height={siteHeight > siteWidth ? siteWidth : siteHeight}>
      <LandscapeSection
        height={siteHeight > siteWidth ? siteWidth : siteHeight}
        width={siteHeight > siteWidth ? siteHeight : siteWidth}
      >
        <img className="landscape-background-image" src={AnobisLandscapeBackground} alt="Anobis Landscape Background" />
        <LandscapeTextHead>Please rotate your device</LandscapeTextHead>
        <LandscapeTextTail>Anobis is best viewed in portrait mode</LandscapeTextTail>
      </LandscapeSection>
    </LandscapeContainer>
  ) : (
    <>{children}</>
  );
};

export default OrientationEncapsulator;
